import { render, staticRenderFns } from "./MatchSummary.vue?vue&type=template&id=d78efcf8&scoped=true&"
import script from "./MatchSummary.vue?vue&type=script&lang=js&"
export * from "./MatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./MatchSummary.vue?vue&type=style&index=0&id=d78efcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78efcf8",
  null
  
)

export default component.exports